// src/serivces/api.js
import axios from "axios";
import axiosInstance from "./axiosInstance";

// const BASE_URL = "http://10.200.39.222:8000";
 const BASE_URL = "https://api.themailwhale.in";
//const BASE_URL = "http://10.200.39.100:8080";

export const sendPhoneNumber = async (phone_number, user_type) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/accounts/resident/send-otp/`,
      { phone_number, user_type },
    );
    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
};

export const verifyOtp = async (phone_number, otp) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/accounts/resident/verify-otp/`,
      {
        phone_number: phone_number.toString(),
        otp: otp.toString(),
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error verifying OTP:",

      error.response?.data || error.message,
    );
    throw error;
  }
};

// Fetch Terms and Privacy Policy
export const fetchTermsAndPrivacy = async () => {
  try {
    const [termsRes, privacyRes] = await Promise.all([
      axios.get(`${BASE_URL}/api/legal/terms/`),
      axios.get(`${BASE_URL}/api/legal/privacy/`),
    ]);

    return {
      terms: termsRes.data || {
        effective_date: "",
        plain_content: "No Terms & Conditions found.",
      },
      privacy: privacyRes.data || {
        effective_date: "",
        plain_content: "No Privacy Policy found.",
      },
    };
  } catch (error) {
    console.error("❌ Error fetching legal content:", {
      message: error.message,
      ...(error.response && {
        status: error.response.status,
        data: error.response.data,
      }),
    });

    return {
      terms: {
        effective_date: "",
        plain_content: "Failed to load Terms & Conditions.",
      },
      privacy: {
        effective_date: "",
        plain_content: "Failed to load Privacy Policy.",
      },
    };
  }
};

// ─── Fetch Company Logos and Names ─────────────────────────────────────────────
export const fetchCompaniesAPI = async () => {
  try {
    // GET request to /api/mobile/companies/
    // const response = await axios.get(`${BASE_URL}/api/mobile/companies/`);
    const response = await axiosInstance.get(
      `${BASE_URL}/api/mobile/resident/show-company/`,
    );

    // The endpoint returns { success: true, data: [ … ] }, so we return the inner array:
    return response.data?.data || [];
  } catch (error) {
    // console.error(
    //   "❌ Company Fetch Error:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

// Add New Company/Brand API
export const addNewCompanyAPI = async (formData) => {
  try {
    const url = `${BASE_URL}/api/mobile/resident/add-company/`;
    console.log("🌐 Calling Add Company API:", url);

    // Debug: Log form data entries
    console.log("📦 FormData Contents for add-company:");
    for (const pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("✅ Add Company API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Add Company API Failed:");
    if (error.response) {
      console.error("📡 Status:", error.response.status);
      console.error("📡 Response Data:", error.response.data);
    } else {
      console.error("📡 Error Message:", error.message);
    }
    throw error;
  }
};

export const signUpApi = async (payload) => {
  try {
    const config = {
      method: "post",
      url: `${BASE_URL}/api/accounts/resident/CompleteResidentProfile/`,
      data: payload,
    };
    const token = JSON.parse(localStorage.getItem("authTokens"))?.access;
    if (token) {
      console.log("➡️ Authorization:", `Bearer ${token}`);
    } else {
      console.warn("⚠️ No token found in localStorage.");
    }

    const response = await axiosInstance(config);

    return response.data;
  } catch (error) {
    console.error("❌ SIGNUP ERROR:", error.response?.data || error.message);
    throw error;
  }
};

// Fetch FAQs
export const fetchFAQs = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/website/faq/`);

    // Ensure we return only the data array
    if (response?.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }

    return [];
  } catch (error) {
    console.error(
      "❌ Error fetching FAQs:",
      error.response ? error.response.data : error.message,
    );
    return [];
  }
};

export const fetchTermsAndConditions = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/website/terms/`);

    // Check HTTP response status
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;

    // Validate and return the first (latest) active Terms
    if (data.success && data.data && data.data.length > 0) {
      return data.data[0];
    } else {
      throw new Error("No Terms & Conditions found");
    }
  } catch (error) {
    console.error("Error fetching Terms & Conditions:", error);
    throw error;
  }
};

//Fetch Privacy Policy data
export const fetchPrivacyPolicy = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/website/privacy/`);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;

    if (data.success && data.data && data.data.length > 0) {
      return data.data[0]; // Return latest Privacy Policy
    } else {
      throw new Error("No Privacy Policy found");
    }
  } catch (error) {
    console.error("Error fetching Privacy Policy:", error);
    throw error;
  }
};
